/* sts-store-locator.js — the /pages/find provider map (sections/sts-store-locator.liquid).
   The provider list is server-rendered <li data-lat data-lng ...>; this file
   re-orders it by distance, pages it, and draws a Leaflet + OpenStreetMap map.
   Search is local: ZIP3/state centroids and US city centroids are theme assets
   (GeoNames, CC BY), fetched on first use. No API key, no geocoding service. */
(function () {
  'use strict';
  var root = document.querySelector('[data-sts-loc]');
  if (!root) return;

  var listEl = root.querySelector('[data-sts-loc-list]');
  var panel = root.querySelector('[data-sts-loc-panel]');
  var statusEl = root.querySelector('[data-sts-loc-status]');
  var moreBtn = root.querySelector('[data-sts-loc-more]');
  var form = root.querySelector('[data-sts-loc-form]');
  var input = root.querySelector('[data-sts-loc-q]');
  var meBtn = root.querySelector('[data-sts-loc-me]');
  var mapEl = root.querySelector('[data-sts-loc-map]');
  var PAGE = parseInt(root.getAttribute('data-page'), 10) || 20;
  var T = {
    all: root.getAttribute('data-all') || '[count] providers',
    near: root.getAttribute('data-near') || 'Providers nearest [place]',
    none: root.getAttribute('data-none') || "We couldn't find [place]."
  };

  var items = [].slice.call(listEl.querySelectorAll('.sts-loc__item')).map(function (li, i) {
    var nameEl = li.querySelector('.sts-loc__name');
    return {
      li: li, i: i,
      lat: parseFloat(li.getAttribute('data-lat')),
      lng: parseFloat(li.getAttribute('data-lng')),
      city: norm(li.getAttribute('data-city')),
      st: li.getAttribute('data-st') || '',
      zip: (li.getAttribute('data-zip') || '').slice(0, 5),
      name: nameEl ? nameEl.textContent : '',
      d: null, marker: null
    };
  });
  var order = items.slice();
  var shown = PAGE;
  var active = null;
  var map = null, originMarker = null;

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[.']/g, '').replace(/\bsaint\b/g, 'st').replace(/\s+/g, ' ').trim();
  }
  function fill(t, k, v) { return t.replace('[' + k + ']', v); }
  function setStatus(t) { statusEl.textContent = t; }

  /* ---------- list ---------- */
  function render() {
    var frag = document.createDocumentFragment();
    order.forEach(function (it, n) {
      it.li.hidden = n >= shown;
      var dEl = it.li.querySelector('.sts-loc__dist');
      if (dEl) dEl.textContent = it.d == null ? '' : (it.d < 10 ? it.d.toFixed(1) : Math.round(it.d)) + ' mi';
      it.li.classList.toggle('has-dist', it.d != null);
      frag.appendChild(it.li);
    });
    listEl.appendChild(frag);
    var left = order.length - shown;
    moreBtn.hidden = left <= 0;
    panel.scrollTop = 0;
  }
  moreBtn.addEventListener('click', function () {
    var first = order[shown];
    shown += PAGE;
    render();
    if (first) { var b = first.li.querySelector('.sts-loc__show'); (b || first.li).focus({ preventScroll: false }); }
  });

  items.forEach(function (it) {
    var actions = it.li.querySelector('.sts-loc__actions');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sts-loc__show';
    b.innerHTML = 'Show on map<span class="sts-visually-hidden">: ' + escapeHtml(it.name) + '</span>';
    b.addEventListener('click', function () { select(it, false); });
    if (actions) actions.insertBefore(b, actions.firstChild);
  });

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function panelScrolls() {
    return panel.scrollHeight > panel.clientHeight + 4 && getComputedStyle(panel).overflowY !== 'visible';
  }

  function select(it, fromMap) {
    if (active) { active.li.classList.remove('is-active'); active.li.removeAttribute('aria-current'); if (active.marker) active.marker.setIcon(pin(false)); }
    active = it;
    it.li.classList.add('is-active');
    it.li.setAttribute('aria-current', 'true');
    if (fromMap) {
      var idx = order.indexOf(it);
      if (idx >= shown) { shown = Math.ceil((idx + 1) / PAGE) * PAGE; render(); }
      if (panelScrolls()) panel.scrollTop = it.li.offsetTop - panel.offsetTop - 8;
    }
    if (!map) return;
    it.marker.setIcon(pin(true));
    it.marker.setZIndexOffset(1000);
    if (!fromMap) {
      map.setView([it.lat, it.lng], Math.max(map.getZoom(), 13));
      var r = mapEl.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    it.marker.openPopup();
  }

  /* ---------- distance ---------- */
  function miles(a, b, c, d) {
    var R = 3958.8, toR = Math.PI / 180;
    var dLat = (c - a) * toR, dLng = (d - b) * toR;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a * toR) * Math.cos(c * toR) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  function sortFrom(lat, lng, place) {
    items.forEach(function (it) { it.d = miles(lat, lng, it.lat, it.lng); });
    order = items.slice().sort(function (a, b) { return a.d - b.d; });
    shown = PAGE;
    render();
    setStatus(fill(T.near, 'place', place));
    if (!map) return;
    if (originMarker) map.removeLayer(originMarker);
    originMarker = window.L.circleMarker([lat, lng], { radius: 8, color: '#FFFFFF', weight: 3, fillColor: '#2F3572', fillOpacity: 1, interactive: false }).addTo(map);
    var pts = [[lat, lng]];
    order.slice(0, 3).forEach(function (it) { pts.push([it.lat, it.lng]); });
    map.fitBounds(pts, { padding: [40, 40], maxZoom: 11 });
  }

  function reset() {
    items.forEach(function (it) { it.d = null; it.li.hidden = false; });
    order = items.slice();
    shown = PAGE;
    render();
    setStatus(fill(T.all, 'count', items.length));
    if (map) { if (originMarker) { map.removeLayer(originMarker); originMarker = null; } fitAll(); }
  }

  /* ---------- local geocoding ---------- */
  var zip3P = null, citiesP = null, citiesParsed = {};
  function getJSON(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function zip3() { return zip3P || (zip3P = getJSON(root.getAttribute('data-zip3')).catch(function (e) { zip3P = null; throw e; })); }
  function cities() { return citiesP || (citiesP = getJSON(root.getAttribute('data-cities')).catch(function (e) { citiesP = null; throw e; })); }
  function cityRows(data, st) {
    if (!citiesParsed[st]) {
      citiesParsed[st] = (data[st] || '').split(';').map(function (r) { var p = r.split('|'); return { n: norm(p[0]), lat: +p[1], lng: +p[2], c: +(p[3] || 1), st: st }; });
    }
    return citiesParsed[st];
  }
  function stateOf(word, g) {
    var w = norm(word);
    if (!w) return '';
    if (w.length === 2 && g.s[w.toUpperCase()]) return w.toUpperCase();
    return g.n[w] || '';
  }

  function search(raw) {
    var q = String(raw || '').trim();
    if (!q) { reset(); return; }
    var zip = q.match(/^(\d{5})(?:-\d{4})?$/);
    if (zip) {
      var z = zip[1];
      var hit = items.filter(function (it) { return it.zip === z; });
      if (hit.length) { sortFrom(hit[0].lat, hit[0].lng, z); return; }
      zip3().then(function (g) {
        var p = g.z[z.slice(0, 3)];
        if (p) sortFrom(p[0], p[1], z); else notFound(q);
      }, function () { notFound(q); });
      return;
    }
    if (/^\d+$/.test(q)) { notFound(q); return; }
    zip3().then(function (g) {
      var parts = q.split(',');
      var cityPart, st = '';
      if (parts.length > 1) {
        st = stateOf(parts.slice(1).join(' '), g);
        cityPart = parts[0];
      } else {
        var words = norm(q).split(' ');
        for (var k = Math.min(2, words.length); k >= 1 && !st; k--) {
          st = stateOf(words.slice(words.length - k).join(' '), g);
          if (st) cityPart = words.slice(0, words.length - k).join(' ');
        }
        if (!st) cityPart = q;
      }
      var c = norm(cityPart);
      if (!c && st) { var sp = g.s[st]; sortFrom(sp[0], sp[1], q); return; }
      var ours = items.filter(function (it) { return it.city === c && (!st || it.st === st); });
      if (ours.length) {
        var la = 0, ln = 0;
        ours.forEach(function (it) { la += it.lat; ln += it.lng; });
        sortFrom(la / ours.length, ln / ours.length, q);
        return;
      }
      return cities().then(function (data) {
        var best = null;
        (st ? [st] : Object.keys(data)).forEach(function (code) {
          cityRows(data, code).forEach(function (r) { if (r.n === c && (!best || r.c > best.c)) best = r; });
        });
        if (best) { sortFrom(best.lat, best.lng, q); return; }
        byName(q);
      });
    }).catch(function () { byName(q); });
  }

  function byName(q) {
    var n = norm(q);
    var hits = items.filter(function (it) { return norm(it.name).indexOf(n) !== -1; });
    if (!hits.length) { notFound(q); return; }
    items.forEach(function (it) { it.d = null; });
    order = hits;
    shown = PAGE;
    render();
    items.forEach(function (it) { if (hits.indexOf(it) === -1) it.li.hidden = true; });
    setStatus(fill(T.near, 'place', q).replace(/nearest/i, 'matching'));
    if (map) map.fitBounds(hits.map(function (it) { return [it.lat, it.lng]; }), { padding: [40, 40], maxZoom: 12 });
  }

  function notFound(q) {
    reset();
    setStatus(fill(T.none, 'place', '“' + q + '”'));
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    search(input.value);
    try {
      var u = new URL(window.location.href);
      if (input.value.trim()) u.searchParams.set('q', input.value.trim()); else u.searchParams.delete('q');
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    } catch (err) { /* old browser: the search still ran */ }
  });
  input.addEventListener('search', function () { if (!input.value) reset(); });

  if (navigator.geolocation && window.isSecureContext !== false) {
    meBtn.hidden = false;
    meBtn.addEventListener('click', function () {
      meBtn.disabled = true;
      navigator.geolocation.getCurrentPosition(function (p) {
        meBtn.disabled = false;
        input.value = '';
        sortFrom(p.coords.latitude, p.coords.longitude, 'you');
      }, function () {
        meBtn.disabled = false;
        setStatus('We could not get your location. Search by city or ZIP code instead.');
      }, { timeout: 10000, maximumAge: 600000 });
    });
  }

  /* ---------- map ---------- */
  var PIN = '<svg viewBox="0 0 28 36" width="28" height="36" aria-hidden="true" focusable="false"><path d="M14 1C7 1 1.5 6.4 1.5 13.3 1.5 22.6 14 35 14 35s12.5-12.4 12.5-21.7C26.5 6.4 21 1 14 1z" fill="FILL" stroke="#FFFFFF" stroke-width="2"/><circle cx="14" cy="13.5" r="4.5" fill="#FFFFFF"/></svg>';
  var icons = {};
  function pin(on) {
    var k = on ? 'on' : 'off';
    if (!icons[k]) {
      icons[k] = window.L.divIcon({
        className: 'sts-loc__pin' + (on ? ' is-active' : ''),
        html: PIN.replace('FILL', on ? '#B4452F' : '#2F3572'),
        iconSize: [28, 36], iconAnchor: [14, 35], popupAnchor: [0, -32]
      });
    }
    return icons[k];
  }
  /* The opening view is the lower 48, where nearly every provider is; Hawaii
     and Puerto Rico are a pan or a search away. */
  function fitAll() {
    var main = items.filter(function (it) { return it.lat > 24 && it.lat < 50 && it.lng > -125 && it.lng < -66; });
    map.fitBounds((main.length ? main : items).map(function (it) { return [it.lat, it.lng]; }), { padding: [24, 24] });
  }
  function popupHtml(it) {
    var li = it.li;
    var addr = li.querySelector('.sts-loc__addr');
    var phone = li.querySelector('.sts-loc__phone a');
    var hours = li.querySelector('.sts-loc__hours');
    var dir = li.querySelector('.sts-loc__dir');
    return '<div class="sts-loc__pop"><strong>' + escapeHtml(it.name) + '</strong>' +
      (addr ? '<p>' + addr.innerHTML + '</p>' : '') +
      (hours ? '<p>' + hours.innerHTML + '</p>' : '') +
      '<p>' + (phone ? '<a href="' + phone.getAttribute('href') + '">' + escapeHtml(phone.textContent) + '</a>' : '') +
      (dir ? (phone ? ' · ' : '') + '<a href="' + dir.getAttribute('href') + '" target="_blank" rel="noopener">Directions</a>' : '') + '</p></div>';
  }

  function initMap() {
    var L = window.L;
    if (!L || !mapEl) { if (mapEl) mapEl.hidden = true; root.classList.add('is-nomap'); return; }
    map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true, attributionControl: true, worldCopyJump: false });
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors · Search data <a href="https://www.geonames.org/" target="_blank" rel="noopener">GeoNames</a>'
    }).addTo(map);
    map.attributionControl.setPrefix('<a href="https://leafletjs.com" target="_blank" rel="noopener">Leaflet</a>');
    items.forEach(function (it) {
      it.marker = L.marker([it.lat, it.lng], { icon: pin(false), title: it.name, alt: it.name, riseOnHover: true })
        .bindPopup(function () { return popupHtml(it); }, { maxWidth: 260, autoPanPadding: [24, 24] })
        .on('click', function () { select(it, true); })
        .addTo(map);
    });
    /* Wheel zoom only after the visitor engages with the map, so scrolling the
       page past it never gets trapped. */
    map.on('focus click', function () { map.scrollWheelZoom.enable(); });
    mapEl.addEventListener('mouseleave', function () { map.scrollWheelZoom.disable(); });
    fitAll();
  }

  reset();
  var q0 = '';
  try { q0 = new URL(window.location.href).searchParams.get('q') || ''; } catch (e) { /* no URL */ }
  initMap();
  if (q0) { input.value = q0; search(q0); }
})();
